import { render, staticRenderFns } from "./edit-report-info.vue?vue&type=template&id=944a278e&scoped=true&"
import script from "./edit-report-info.vue?vue&type=script&lang=ts&"
export * from "./edit-report-info.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "944a278e",
  null
  
)

export default component.exports